import React from 'react'
import { Paragraph } from 'src/components'

type Props = {
  label: string
  url: string
  showLabel?: boolean
}

export function Link(props: Props) {
  return (
    <>
      {!props.showLabel && (
        <Paragraph className="inline mr-2">{props.label}</Paragraph>
      )}

      <a
        href={props.url}
        target="_blank"
        rel="noreferrer"
        className="text-base font-normal break-all cursor-pointer text-theme-500 decoration-dotted underline-offset-4 hover:underline active:text-theme-600"
      >
        {props.showLabel ? props.label : props.url}
      </a>
    </>
  )
}
